import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
// import MenuIcon from '@mui/icons-material/Menu';
import {Tooltip} from "@mui/material";
import {useState} from "react";


export default function CustomInputSearch({search, clear}) {
  const [searchValue, setSearchValue] = useState('');
  const [alreadySearched, setAlreadySearched] = useState(false);

  return (
    <Paper
      component="form"
      sx={{p: '2px 4px', display: 'flex', alignItems: 'center', width: 360}}
    >
      {/*<IconButton sx={{p: '10px'}} aria-label="menu">*/}
      {/*  <MenuIcon/>*/}
      {/*</IconButton>*/}
      <InputBase
        sx={{ml: 1, flex: 1}}
        placeholder="Search from the current folder..."
        inputProps={{'aria-label': 'search items'}}
        value={searchValue}
        onChange={(e) => {
          const sv = e.target.value.trim();
          if (sv === '' && sv.length === 0 && alreadySearched) {
            setSearchValue('');
            clear();
          } else {
            setSearchValue(sv);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            setAlreadySearched(true);
            search(searchValue);
          }
        }}
      />
      <Tooltip arrow title="Clear">
        <IconButton
          type="button" sx={{p: '10px'}} aria-label="clear"
          disabled={!searchValue.trim()}
          onClick={() => {
            setSearchValue('');
            alreadySearched && clear();
          }}
        >
          <ClearIcon/>
        </IconButton>
      </Tooltip>
      <Divider sx={{height: 28, m: 0.5}} orientation="vertical"/>
      <Tooltip arrow title="Search">
        <IconButton
          color="primary" sx={{p: '10px'}} aria-label="search" disabled={!searchValue.trim()}
          onClick={() => {
            setAlreadySearched(true);
            search(searchValue);
          }}>
          <SearchIcon/>
        </IconButton>
      </Tooltip>
    </Paper>
  );
}
